import { mailingAddressFragment } from '../mailingAddressFragment';

export const customerFragment = `
  fragment CustomerFragment on Customer {
    id
    firstName
    lastName
    acceptsMarketing
    createdAt
    displayName
    email
    phone
    defaultAddress {
      id
    }
    addresses(first:10) {
      edges{
        node {
          ...MailingAddressFragment
        }
      }
    }
    metafield(namespace: "custom", key: "birthday") {
    value
    }
    orders(first: 100, reverse:true){
      edges {
        node {
          id
          fulfillmentStatus
          name
          orderNumber
          email
          cancelReason
          processedAt
          financialStatus
          totalShippingPrice {
            amount
            currencyCode
          }
          totalPrice {
            amount
            currencyCode
          }
          currentTotalTax {
            amount
          }
          shippingAddress {
            ...MailingAddressFragment
          }
          lineItems(first:100) {
            edges {
              node {
                customAttributes {
                  key
                  value
                }
                title
                quantity
                discountedTotalPrice {
                  amount
                }
                variant {
                  id
                  sku
                  product {
                    id
                  }
                }
              }
            }
          }
          discountApplications(first:10) {
            edges {
              node {
                value {
                  __typename
                  ... on PricingPercentageValue {
                    percentage
                  }
                  ... on MoneyV2 {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
          successfulFulfillments(first:10) {
            trackingInfo {
              url
              number
            }
          }
        }
      }
    }
  }
  ${mailingAddressFragment}
`;
